import React from 'react';
import { useTranslation } from 'react-utilities';
import { TPunishment } from '../../utils/types';
import { NAPageItemConfigType, PageItemRenderingProps } from '../ConfigTypes';
import getFormattedFullDate from '../../utils/getFormattedFullDate';
import isBanType from '../../utils/isBanType';

/**
 * Ban description. Shown to banned users
 */
const BanDescriptionPageItem = (props: PageItemRenderingProps): JSX.Element => {
  const { translate } = useTranslation();
  const { punishmentData } = props;
  const endDateFormattedString =
    punishmentData.endDate != null ? getFormattedFullDate(punishmentData.endDate) : '';

  return (
    <div data-testid='ban-description'>
      {translate('Description.Ban', { date: endDateFormattedString })}
    </div>
  );
};

const BanDescriptionPageItemConfig: NAPageItemConfigType = {
  getIsVisible: (punishmentData: TPunishment) => {
    return isBanType(punishmentData.punishmentTypeDescription);
  },
  renderComponent: BanDescriptionPageItem,
  configName: 'ban-description'
};

export default BanDescriptionPageItemConfig;
